/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconCalendarIncomingArrow(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 21 21"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.875 15.998a2.73 2.73 0 0 1-2.73 2.727H14.01a.6.6 0 1 1 0-1.2h4.133c.845 0 1.53-.684 1.53-1.527V7.665H4.12v2.04a.6.6 0 0 1-1.201 0V4.938a2.73 2.73 0 0 1 2.73-2.727h1.032v-.818a.6.6 0 0 1 1.202 0v.818h8.063v-.818a.6.6 0 0 1 1.202 0v.818h.996c1.508 0 2.731 1.221 2.731 2.727zM5.649 3.411h1.032v.818a.6.6 0 0 0 1.202 0V3.41h8.063v.818a.6.6 0 0 0 1.202 0V3.41h.996c.845 0 1.53.684 1.53 1.527v1.527H4.12V4.938c0-.843.685-1.527 1.53-1.527"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.826 20.745a.6.6 0 0 0 .651-.118l3.773-3.61a.6.6 0 0 0 0-.866l-3.773-3.61a.601.601 0 0 0-1.016.433v1.239H6.019c-2.105 0-3.935-2.114-3.942-4.354a.6.6 0 0 0-1.202.002v3.958a5.15 5.15 0 0 0 5.153 5.147h1.433v1.228a.6.6 0 0 0 .365.551m.836-1.957v-.422a.6.6 0 0 0-.6-.6H6.027a3.95 3.95 0 0 1-3.951-3.947v-.496c.932 1.233 2.334 2.09 3.942 2.09h2.042a.6.6 0 0 0 .601-.6v-.433l2.304 2.204z"
        clipRule="evenodd"
      />
    </svg>
  );
}
